import * as React from 'react';
import { useDispatch } from 'react-redux';
import { TDispatch } from '../../../../../../redux';
import { joinFairPlayInit } from '../../../../../../redux/reducers';
import { OnlyForFairPlayersFatalError } from './OnlyForFairPlayersFatalError';

export const OnlyForFairPlayersFatalErrorContainer = () => {
  const dispatch = useDispatch<TDispatch>();

  const handleClickRetryButton = React.useCallback(() => {
    dispatch(joinFairPlayInit());
  }, [dispatch]);

  return <OnlyForFairPlayersFatalError onClickRetryButton={handleClickRetryButton} />;
};
